var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("estimates-control", {
        attrs: {
          id: "general-expenses",
          titleKey: "BudgetaryEstimate.GeneralExpenses.Title",
          tableKey: "BudgetaryEstimate.GeneralExpenses.Entry",
          instructionsKey:
            "BudgetaryEstimate.GeneralExpenses.Title_Instructions",
          showRowTotals: true,
          required: true
        },
        model: {
          value: _vm.breakdown,
          callback: function($$v) {
            _vm.breakdown = $$v
          },
          expression: "breakdown"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }